export enum UserSubscriptionStatus {
  PENDING = 'Pending',
  ACTIVE = 'Active',
  CANCELED = 'Canceled',
  PAYMENT_FAILED = 'Payment failed',
  BILLING_PERIOD_CHANGED = 'Billing period changed',
}

export enum FileType {
  AUDIO = 'audio',
  DOCUMENT = 'document',
  IMAGE = 'image',
}

export enum WebsocketTypeEnum {
  DOCUMENT_STATUS = 'document_status',
  NOTIFICATION = 'notification',
  MESSAGE_RESPONSE = 'message_response',
  DOCUMENT_GENERATOR_STATUS = 'document_generator_status',
  DOCUMENT_PARSING_PREVIEW_STATUS = 'document_parsing_preview_status',
  DOCUMENT_INSTANCE_STATUS = 'document_instance_status',
}

export enum Author {
  User = 'user',
  Chatbot = 'chatbot',
}

export enum MessageStatus {
  SUCCESS = 'success',
  FAILED = 'failed',
}

export enum ChatType {
  generalResearch = 'General Research',
  depositionSummary = 'Deposition Summary',
  openAI = 'Open AI',
  ragAssistants = 'RAG Assistants',
  ragCompletions = 'RAG Completions',
  documentVersion = 'Document Version',
}

export enum DocumentPromptPreviewStatus {
  DRAFT = 'Draft',
  PENDING = 'Pending',
  FAILED = 'Failed',
  COMPLETED = 'Completed',
}

export enum MultiDocumentAgentTemplateStatus {
  DRAFT = 'Draft',
  PENDING = 'Pending',
  FAILED = 'Failed',
  COMPLETED = 'Completed',
}

export enum DocumentGeneratorTemplateStatus {
  DRAFT = 'Draft',
  PENDING = 'Pending',
  FAILED = 'Failed',
  COMPLETED = 'Completed',
}

export enum DepositionSummaryTemplateStatus {
  DRAFT = 'Draft',
  PENDING = 'Pending',
  FAILED = 'Failed',
  COMPLETED = 'Completed',
}

export enum UseCaseTemplateStatus {
  DRAFT = 'Draft',
  PENDING = 'Pending',
  FAILED = 'Failed',
  COMPLETED = 'Completed',
}

export enum PromptCategoryKey {
  EXTRACTION = 'extraction',
  GENERATION = 'generation',
  EXAMPLE_EXTRACTION = 'example_extraction',
  RAG = 'ground_x',
}

export enum PromptKey {
  SYSTEM_EXTRACTION = 'system_extraction',
  MISTAKES_EXTRACTION = 'mistakes_extraction',
  SYSTEM_GENERATION = 'system_generation',
  USER_GENERATION = 'user_generation',
  SYSTEM_EXAMPLE_EXTRACTION = 'system_example_extraction',
  USER_EXAMPLE_EXTRACTION = 'user_example_extraction',
  LIABILITY_RAG = 'liability_rag',
  ICD_EXTRACTION = 'icd_extraction',
}

export enum DocumentGeneratorTemplateFileType {
  EXAMPLE = 'Example',
  REFERENCE = 'Reference',
}

export enum DepositionSummaryFileType {
  EXAMPLE = 'Example',
  REFERENCE = 'Reference',
}

export enum UseCaseFileType {
  EXAMPLE = 'Example',
  REFERENCE = 'Reference',
  TEMPLATE = 'Template',
}

export enum DocumentGeneratorTemplateCustomFieldPromptType {
  EXTRACTION = 'E',
  GENERATION = 'G',
}

export enum DepositionSummaryTemplatePromptType {
  TOPIC_EXTRACTION = 'TE',
  EXHIBIT_EXTRACTION = 'EE',
  GENERATION = 'GE',
}

export enum UseCaseTemplatePromptType {
  EXTRACTION = 'E',
  GENERATION = 'G',
}

export enum CompanyUserStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  InvitationPending = 'Invitation pending',
  AccountPendingApproval = 'Pending approval',
  InvitationExpired = 'Invitation Expired',
}

export enum SubscriptionPlanPeriod {
  MONTH = 'Month',
  YEAR = 'Year',
}

export enum SubscriptionStatus {
  ACTIVE = 'Active',
  PENDING = 'Pending',
  CANCELED = 'Canceled',
  PAYMENT_FAILED = 'Payment failed',
  BILLING_PERIOD_CHANGED = 'Billing period changed',
  NOT_ACTIVE = 'Not active',
  PLAN_UPGRADED = 'Plan upgraded',
}

export enum MultiDocumentAgentTemplateType {
  DEPOSITION_SUMMARY = 'Deposition Summary',
  DEMAND_LETTER = 'Demand Letter',
  CUSTOM_GPT = 'Custom GPT',
  USE_CASE = 'Use Case',
}

export enum DocumentType {
  DEPOSITION_SUMMARY = 'Deposition Summary',
  DEMAND_LETTER = 'Demand Letter',
  USE_CASE = 'Use Case',
}
